// extracted by mini-css-extract-plugin
export default {"page":"y1-z","cartModal":"z1-z","checkout":"A1-z","placeholder":"B1-z","account":"C1-z"};